export default __webpack_public_path__ + "static/media/fabled_forest.c3104a84.svg";